export default __webpack_public_path__ + "static/media/added-3.507487ad.svg";